import { render, staticRenderFns } from "./notifications-menu.vue?vue&type=template&id=da7b5374"
import script from "./notifications-menu.vue?vue&type=script&lang=js"
export * from "./notifications-menu.vue?vue&type=script&lang=js"
import style0 from "./notifications-menu.vue?vue&type=style&index=0&id=da7b5374&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports